import React from 'react'
import PropTypes from 'prop-types'

import { graphql, useStaticQuery } from 'gatsby'
import { CAL_PLUS_FEATURES, RETAIL_CAL_PLUS_FEATURES } from './constants'
import {
  MatrixContainer,
  Table,
  Row,
  HeaderCell,
  Cell,
  CheckCell,
  CheckMark,
  Title,
  FeatureName,
} from './styles'

const Matrix = ({ retailPage }) => {
  const { grayCheck, goldCheck } = useStaticQuery(graphql`
    query MatrixQuery {
      grayCheck: file(relativePath: { eq: "check-gray.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      goldCheck: file(relativePath: { eq: "check-gold.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)

  const calPlusFeatures = retailPage ? RETAIL_CAL_PLUS_FEATURES : CAL_PLUS_FEATURES
  return (
    <MatrixContainer>
      <Table>
        <thead>
          <Row last>
            <HeaderCell>
              <Title>Basic</Title>
            </HeaderCell>
            <HeaderCell>
              <Title>Plus</Title>
            </HeaderCell>
            <HeaderCell />
          </Row>
        </thead>
        <tbody>
          {calPlusFeatures.map((row, index) => (
            <Row key={index} last={index === calPlusFeatures.length - 1}>
              <CheckCell>
                {row.checked && (
                  <CheckMark image={grayCheck.childImageSharp.gatsbyImageData} alt="check mark" />
                )}
              </CheckCell>
              <CheckCell>
                <CheckMark
                  hide={row.noPlus}
                  image={goldCheck.childImageSharp.gatsbyImageData}
                  alt="check mark"
                />
              </CheckCell>
              <Cell>
                <FeatureName>{row.name}</FeatureName>
              </Cell>
            </Row>
          ))}
        </tbody>
      </Table>
    </MatrixContainer>
  )
}

Matrix.propTypes = {
  retailPage: PropTypes.bool,
}

export default Matrix
